import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PersonGbMasterDetailEntryMeta, PersonGbVersionDetailEntryMeta } from '../../../../core/gb-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { FormatUidPipe } from '../../../../shared/pipes/format/format-uid.pipe';

@Component({
  selector: 'cap-persongb-oeffentl-rechtl-koerperschaft',
  templateUrl: './persongb-oeffentl-rechtl-koerperschaft.component.html',
  styleUrls: ['./persongb-oeffentl-rechtl-koerperschaft.component.scss'],
  imports: [KopfdatenelementComponent, KompaktTimepointComponent, TranslatePipe, FormatUidPipe]
})
export class PersongbOeffentlRechtlKoerperschaftComponent implements OnInit {
  @Input()
  public version: PersonGbVersionDetailEntryMeta;
  @Input()
  public master: PersonGbMasterDetailEntryMeta;

  constructor(public translate: TranslateService) {
    keysToTranslate<string>([
      'Personalien',
      'Heimatort',
      'NameDerEltern',
      'NameEhegatte',
      'Geschlecht',
      'Zivilstand',
      'Nationalitaet',
      'Personengruppe',
      'Sprache',
      'Anrede',
      'AHVNummer',
      'AHVVersichertennummer',
      'UidStatus',
      'Gueltig',
      'Adressen'
    ]);
  }

  ngOnInit() {}
}
